import { render, staticRenderFns } from "./LegoBtn.vue?vue&type=template&id=1a43e554&scoped=true"
var script = {}
import style0 from "./LegoBtn.vue?vue&type=style&index=0&id=1a43e554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a43e554",
  null
  
)

export default component.exports